import { useDisclosure } from '@mantine/hooks'
import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

import MensagemInformacao from '../../../components/componentesModais/mensagens/mensagemInformacao'
import '../../../css/painelDispositivos/dspSimcard/dspAcoes.css'
import info from '../../../icones/iconesVersaoVerde/icone-info.svg'
import {
  desabilitarAcoes,
  desabilitarAcoesCliente,
  filtrosArrayBarra,
  limpadorFiltros,
  mudarFiltros,
  mudarManejador,
  mudarPermissaoElementoAcao,
  recarregarBarraFiltragem,
  revelarBarraFiltragem
} from '../../../redux/actions/index'
import { SolicitationsService } from '../../../services/http/solicitations.service'
import { useGlobal } from '../../../stores/useGlobal'
import { validadorPermissaoElemento } from '../../../utils/verificadorPermissaoElemento'
import ActionIcon from '../../Mantine/ActionIcon'
import Botao from '../../Mantine/Botao'
import Group from '../../Mantine/Group'
import Modal from '../../Mantine/Modal'
import Select from '../../Mantine/Select'
import DetalhamentoSolicitacaoSimcardVirgem from '../../Solicitacoes/SimcardsVirgens/detalhamentoSolicitacaoSimcardVirgem'
import Table from '../../Table'

import * as S from './styles'

let valorLimite = 50
let totalItens = 58
let contador = 0
let totalPaginas = 0
let auxData = []

const TableprimaryKey = 'CodigoSolicitacao'
const COUNT_ITEMS = true

const SUCCESSFUL_STATUS = ['Concluída', 'Concluída parcial']

const columns = [
  {
    dataField: 'CodigoSolicitacao',
    text: 'Cód. solicitação',
    headerClasses: 'nao-selecionavel',
    sort: true
  },
  {
    dataField: 'Operadora',
    text: 'Operadora',
    headerClasses: 'nao-selecionavel',
    sort: true,
    headerWrapperClasses: 'operadoraFinal'
  },
  {
    dataField: 'TipoSolicitacao',
    headerClasses: 'nao-selecionavel',
    text: 'Tipo da solicitação',
    sort: true
  },
  {
    dataField: 'Status',
    headerClasses: 'nao-selecionavel',
    text: 'Status',
    sort: true,
    formatter: (cell) => {
      return (
        <S.StatusWrapper>
          <S.StatusElipse status={cell} />
          {cell}
        </S.StatusWrapper>
      )
    }
  },
  {
    dataField: 'DataSolicitacao',
    headerClasses: 'nao-selecionavel',
    text: 'Data da solicitação',
    sort: true
  },
  {
    dataField: 'Usuario',
    headerClasses: '',
    text: 'Usuário',
    sort: true,
    formatter: (cell) => {
      return cell === 'automacao@virtueyes.com.br' ? (
        <div style={{ display: 'flex', 'justify-content': 'space-between' }}>
          <span>{cell}</span>
          <ActionIcon
            alt="info"
            variant="transparent"
            icon={info}
            tooltip={{
              label:
                'O prazo de pré-provisionamento expirou e o SIM card foi automaticamente provisionado pelo sistema.',
              width: 280
            }}
          />
        </div>
      ) : (
        cell
      )
    }
  },
  {
    dataField: 'QtdDeSimcards',
    headerClasses: 'nao-selecionavel',
    text: 'Quantidade de SIM cards',
    sort: true
  }
]

function TabelaSolicitacoesSimcardsVirgens() {
  const history = useHistory()
  const [opened, { open, close }] = useDisclosure(false)
  const [
    openedErroMostrarEmDispositivos,
    {
      open: openErroMostrarEmDispositivos,
      close: closeErroMostrarEmDispositivos
    }
  ] = useDisclosure(false)

  const recarregarBarraFiltragemValor = useSelector(
    (state) => state.filtrosState.recarregarBarraFiltragem
  )

  const permissaoElemento = useSelector(
    (state) => state.permissaoState.permissaoElemento
  )

  const [permissaoDescricao, setPermissaoDescricao] = useState()

  const {
    filtros,
    busca,
    setFiltros,
    revelarBarraFiltro,
    setRevelarBarraFiltro,
    buscaArquivo,
    separadorLinhaBusca,
    exportarRelatorio,
    setExportarRelatorio,
    mostrarAcao,
    setMostrarAcao,
    setIsLoadingGlobal
  } = useGlobal()

  const { getWhitechip, createReport, createPeriodReport, getDevices } =
    SolicitationsService

  const [paginaAtual, setPaginaAtual] = useState(1)
  const [periodo, setPeriodo] = useState('')
  const [solicitations, setSolicitations] = useState([])
  const [mostrarAlertaRelatorio, setMostrarAlertaRelatorio] = useState(false)
  const [itensSelecionados, setItensSelecionados] = useState([])

  const mostrarEmDispositivos =
    mostrarAcao === 'revelarMostrarEmDispositivosSolicitacoesSimcardsEmBranco'

  useEffect(() => {
    async function handlerVerificarPermissaoAcao() {
      const validarPermissoes = await validadorPermissaoElemento(
        permissaoElemento,
        'veye/solicitacoes/simcardsEmBranco/acoes'
      )

      const permissaoDesc = await validadorPermissaoElemento(
        permissaoElemento,
        'veye/solicitacoes/simcardsEmBranco/detalhamento'
      )
      despacho(mudarPermissaoElementoAcao(!validarPermissoes))
      setPermissaoDescricao(permissaoDesc)
    }
    handlerVerificarPermissaoAcao()
  }, [permissaoElemento])

  useQuery(
    [
      `whitechip/solicitations?page=${paginaAtual}`,
      paginaAtual,
      valorLimite,
      filtros,
      busca,
      buscaArquivo,
      true
    ],
    async () => {
      try {
        setIsLoadingGlobal(true)
        return await getWhitechip(
          paginaAtual,
          valorLimite,
          filtros,
          busca,
          buscaArquivo,
          separadorLinhaBusca,
          COUNT_ITEMS
        )
      } catch (err) {
        console.error(err)
      } finally {
        setIsLoadingGlobal(false)
      }
    },
    {
      onSuccess: (data) => {
        contador = (paginaAtual - 1) * valorLimite
        totalItens = data?.item_count
        totalPaginas = Math.ceil(totalItens / valorLimite)

        const novosItens = [...auxData]

        data.solicitations?.forEach((iccid, index) => {
          novosItens[contador + index] = iccid
        })

        setSolicitations(novosItens)
      },
      keepPreviousData: false,
      refetchOnWindowFocus: false
    }
  )

  const despacho = useDispatch()

  useEffect(() => {
    despacho(mudarManejador('solicitacoesSimcardsVirgens'))
  }, [despacho])

  const getOptions = () => {
    const arrOpcoes = Array.from({ length: 4 }, (_, i) => {
      const auxDate = new Date()
      auxDate.setMonth(auxDate.getMonth() - i)
      const aux = auxDate.toISOString().slice(0, 7).replace('-', '/')
      return { label: aux, value: aux }
    })

    return arrOpcoes
  }

  const onConfirm = () => {
    createPeriodReport(periodo)
    setMostrarAlertaRelatorio(true)
    setExportarRelatorio({})
    close()
  }

  const handleMostrarEmDispositivos = async () => {
    try {
      const { data: iccidList } = await getDevices(
        itensSelecionados.CodigoSolicitacao
      )

      //! ESSE setFiltros É SOMENTE PARA CONTROLE DENTRO USEEFFECT QUE LIMPA OS FILTROS AO ENTRAR NESSA TELA
      setFiltros({ ICCID: iccidList })
      despacho(mudarFiltros({ ICCID: iccidList }))
      despacho(revelarBarraFiltragem(true))
      despacho(filtrosArrayBarra(['ICCIDS Provisionados?ICCID']))
      despacho(recarregarBarraFiltragem(!recarregarBarraFiltragemValor))
      despacho(limpadorFiltros(false))
      history.push('/veye/dispositivos')
    } catch (err) {
      console.error(err)
    } finally {
      setMostrarAcao(undefined)
    }
  }

  useEffect(() => {
    if (!filtros.vazio) {
      setFiltros({ vazio: 'vazio' })
      setRevelarBarraFiltro(false)
      despacho(mudarFiltros({ vazio: 'vazio' }))
      despacho(revelarBarraFiltragem(false))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setPaginaAtual(1)
  }, [filtros])

  useEffect(() => {
    if (
      exportarRelatorio &&
      exportarRelatorio?.acao === 'exportarSolicitacaoSimcardsEmBranco'
    ) {
      if (exportarRelatorio.tipo === 'Periodo') {
        setPeriodo('')
        open()
      } else {
        (async () => {
          await createReport(
            itensSelecionados.CodigoSolicitacao,
            exportarRelatorio.tipo
          )
          setMostrarAlertaRelatorio(true)
          setExportarRelatorio({})
        })()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exportarRelatorio])

  useEffect(() => {
    if (!mostrarEmDispositivos) return
    setIsLoadingGlobal(true)

    const solicitation = solicitations.find(
      (s) => s.CodigoSolicitacao === itensSelecionados.CodigoSolicitacao
    )

    if (SUCCESSFUL_STATUS.includes(solicitation?.Status))
      handleMostrarEmDispositivos()
    else {
      openErroMostrarEmDispositivos()
      setMostrarAcao('')
    }
    setIsLoadingGlobal(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mostrarEmDispositivos])

  const renderDetalhamentoLinha = (row) => {
    return (
      <DetalhamentoSolicitacaoSimcardVirgem
        cdSolicitacao={row?.CodigoSolicitacao}
      />
    )
  }

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      despacho(desabilitarAcoes(false))
      despacho(desabilitarAcoesCliente(true))
      setItensSelecionados(row)
    } else {
      despacho(desabilitarAcoes(true))
      despacho(desabilitarAcoesCliente(false))
    }
  }

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  const itensSelecionadosTable = itensSelecionados?.[TableprimaryKey]
    ? [itensSelecionados[TableprimaryKey]]
    : []

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  return (
    <div>
      <S.TabelaSolicitacoesWrapper>
        <Table
          key={`table-${permissaoDescricao}`}
          keyField={TableprimaryKey}
          clickToSelect
          revelarContador
          itens={solicitations}
          colunas={columns}
          permissaoDetalhamentoLinha={permissaoDescricao}
          detalhamentLinha={renderDetalhamentoLinha}
          revelarBarraFiltro={revelarBarraFiltro}
          getTotalItensNaPagina={getTotalItensNaPagina}
          getLimiteNaPagina={getTotalItensNaPagina}
          pagination={{
            paginaAtual,
            valorLimite,
            totalPaginas,
            totalItens,
            contador,
            trocarPagina
          }}
          selection={{
            itensSelecionados: itensSelecionadosTable,
            modeSelection: 'radio',
            handleOnSelect
          }}
        />
      </S.TabelaSolicitacoesWrapper>
      {mostrarAlertaRelatorio && (
        <div id="mensagem-relatorio" className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemInformacao
              handleMensagemInformacao={() => setMostrarAlertaRelatorio(false)}
              mensagemTitulo="O arquivo está sendo gerado"
              mensagemParagrafo1="Esse processo levará alguns minutos, você poderá fazer o download do seu arquivo na tela de Relatórios assim que o link do mesmo estiver disponível"
              mensagemBotao="Voltar"
              marginTop={40}
            />
          </div>
        </div>
      )}
      {openedErroMostrarEmDispositivos && (
        <Modal
          width="444px"
          type="alerta"
          opened={openedErroMostrarEmDispositivos}
        >
          <S.modalMensagem>
            <div className="gap-row">
              <h6>Não é possível exibir em dispositivos</h6>
              <p>A solicitação ainda não foi concluída.</p>
            </div>
            <div>
              <Group position="left">
                <Botao
                  variant="primary"
                  label="Fechar"
                  onClick={() => closeErroMostrarEmDispositivos()}
                />
              </Group>
            </div>
          </S.modalMensagem>
        </Modal>
      )}

      <Modal
        width="444px"
        titulo="Relatório por período"
        type="default"
        opened={opened}
        close={close}
        onConfirm={onConfirm}
        disableConfirm={!periodo}
      >
        <Select
          label="Período"
          width="220px"
          options={getOptions()}
          placeholder="Selecione"
          value={periodo}
          onChange={(e) => setPeriodo(e)}
        />
      </Modal>
    </div>
  )
}

export default React.memo(TabelaSolicitacoesSimcardsVirgens)
